import { registeredTableHandlers } from '@/global/components/view-layouts/tabs-layout/config/registered-table-handlers'
import { api } from '@/global/services/api'

const DEFAULT_EMPTY_VALUE = '--'
export default {
  methods: {
    showEdit (event) {
      const { id, name } = event?.data || {}
      this.$router.push({
        name: 'PartnerLocation',
        params: {
          id
        },
        query: {
          partner_location: name || DEFAULT_EMPTY_VALUE
        }
      }).then()
    },

    onPartnerLocationActivation (event) {
      const { deactivated_at: deactivatedAt, id, name } = event?.data || {}
      if (!id) {
        return
      }
      const title = !deactivatedAt ? this.$t('administration/partner_location.partner_location_deactivation') : this.$t('administration/partner_location.partner_location_activation')
      this.$set(this.informationDialogConfig, 'title', title + ' - ' + (name || '/'))
      this.$set(this.informationDialogConfig, 'positiveBtnText', !deactivatedAt ? this.$t('base.deactivate') : this.$t('base.activate'))
      this.$set(this.informationDialogConfig, 'message', !deactivatedAt ? this.$t('administration/partner_location.confirm_deactivation') : this.$t('administration/partner_location.confirm_activation'))
      this.$set(this.informationDialogConfig, 'callbackFn', () => this.partnerLocationActivation(event))
      this.$set(this.informationDialogConfig, 'openDialog', true)
    },

    async partnerLocationActivation (event) {
      try {
        const { id, deactivated_at: deactivatedAt } = event?.data || {}
        const { fetchData } = registeredTableHandlers?.partnerLocations || {}
        await api('administration').patch(`partner-locations/${id}/${deactivatedAt ? 'activate' : 'deactivate'}`)

        this.$set(this.informationDialogConfig, 'openDialog', false)
        if (typeof fetchData === 'function') {
          fetchData()
        }
      }
      catch (exception) {
        console.error(exception)
      }
    },

    onPartnerLocationDelete (event) {
      const { id, name } = event?.data || {}
      if (!id) {
        return
      }

      const title = this.$t('administration/partner_location.partner_location_deletion')
      this.$set(this.informationDialogConfig, 'title', title + ' - ' + (name || '/'))
      this.$set(this.informationDialogConfig, 'positiveBtnText', this.$t('base.save'))
      this.$set(this.informationDialogConfig, 'message', this.$t('administration/partner_location.confirm_delete'))
      this.$set(this.informationDialogConfig, 'callbackFn', () => this.partnerLocationDelete(event))
      this.$set(this.informationDialogConfig, 'openDialog', true)
    },

    async partnerLocationDelete (event) {
      try {
        const { id } = event?.data || {}
        const { fetchData } = registeredTableHandlers?.partnerLocations || {}

        await api('administration').delete(`partner-locations/${id}`)

        this.$set(this.informationDialogConfig, 'openDialog', false)
        if (typeof fetchData === 'function') {
          fetchData()
        }
      }
      catch (exception) {
        console.error(exception)
      }
    }
  }
}
